import * as React from 'react';
import styled from 'styled-components';

const StyledItemTitle = styled.span`
  display: block;
  font-size: 16px;
  text-overflow: ellipsis;
`;

export const ListItemTitle = ({
  children,
  ...props
}: React.HTMLAttributes<any>) => {
  return <StyledItemTitle {...props}>{children}</StyledItemTitle>;
};
